module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "doScheduler",
    staticClass: "do-scheduler",
    style: ({
      maxHeight: _vm.schedulerMaxHeight + 'px'
    })
  }, [_c('ul', {
    staticClass: "do-scheduler__list",
    style: ({
      'width': _vm.slotWidth * 48 + 'px'
    })
  }, [_c('ul', {
    staticClass: "scheduler__header__times"
  }, _vm._l((_vm.hoursInLocale), function(number) {
    return _c('li', {
      style: ({
        minWidth: _vm.slotWidth * 2 + 'px'
      })
    }, [_vm._v(_vm._s(number))])
  }), 0), _vm._v(" "), _vm._l((_vm.calendarsWithEvents), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "do-scheduler__list__item",
      style: ({
        height: (_vm.slotHeight * calendar.vColumns) + 'px'
      })
    }, [_c('div', {
      staticClass: "do-scheduler__list__item__name"
    }, [_c('h4', [_vm._v(_vm._s(calendar.name))])]), _vm._v(" "), _c('ul', {
      staticClass: "do-scheduler__item__events",
      style: ({
        'width': _vm.slotWidth * 48 + 'px',
        height: (_vm.slotHeight * calendar.vColumns) + 'px'
      })
    }, [_vm._l((calendar.vPresence), function(presence) {
      return _c('li', {
        staticClass: "do-scheduler__item__events__presence",
        style: ({
          left: presence.left + 'px',
          right: presence.right + 'px'
        })
      })
    }), _vm._v(" "), _vm._l((calendar.vEvents), function(event) {
      return _c('li', {
        key: event.id,
        staticClass: "do-scheduler__item__events__event",
        style: (_vm.getEventStyle(event))
      }, [_c('div', {
        staticClass: "do-scheduler__item__events__event__title"
      }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('div', {
        staticClass: "do-scheduler__item__events__event__klass"
      }, [_vm._v(_vm._s(event.vKlasses))])])
    })], 2)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b586c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Substitution/Scheduler.vue
// module id = 1663
// module chunks = 1